<template>
<div class="smart-form">
  <div class="smart-icon">
      <img src="../assets/bahn.png" width="120px"/>
     </div>
    <div class="screentime-hl">Wie ist die Lage des Schienennetzes?</div>
    
  <div class="screentime-form">
      <form v-if="hasQuizForm"> 
        <br>
           <div class="inner-form">
         <button class="gen_button" v-on:click.prevent="generateOption1">gut</button>
          &nbsp;&nbsp;
         <button class="gen_button" v-on:click.prevent="generateOption2">durchschnittlich</button>
          &nbsp;&nbsp;
         <button class="gen_button" v-on:click.prevent="generateOption3">eher schlecht</button>
<br>
 <br>
</div></form>
  </div>
  <div v-if="hasChoosen" class="smartphone-dataviz">
  <br>
         <div class="screentime-description" v-html="quizDescription"> <br><br>
        </div>
    <br><br>
   <div class="dataviz-source"> Quelle: Allianz pro Schiene</div>
  </div>
  </div>
</template>


<script>
export default {
  name: 'Quiz',
  props: {
    
  },
  data() {
        return {
            optionChoosen: "",
            hasChoosen: false,
            hasQuizForm:true       }     
    },
    computed: {
       
         quizDescription: function () {
        let smartAppMsg="";
            if (this.optionChoosen == "Option1") {
                smartAppMsg= "Sehr zuversichtlich von Ihnen! Leider ist die Lage des deutschen Schienennetzes  verbesserungswürdig! In den letzten 25 Jahren hat der Personenverkehr um 40,8 Prozent und der Güterverkehr um 83,4 Prozent zugenommen, während das Schienennetz um 14,9 Prozent verkleinert wurde. <br><br><b>33.000 Kilometer </b><br>sind heute noch in Betrieb.<br>Seit 1994 wurde das Schienennetz um 5100 Kilometer reduziert."
            }
            if (this.optionChoosen == "Option2") {
                smartAppMsg= "Am Ende ist das natürlich eine Frage der Perspektive. Laut unserer Daten ist die Lage des deutschen Schiennetzes leider verbesserungswürdig! In den letzten 25 Jahren hat der Personenverkehr um 40,8 Prozent und der Güterverkehr um 83,4 Prozent zugenommen, während das Schienennetz um 14,9 Prozent verkleinert wurde. <br><br><b>33.000 Kilometer </b><br>sind heute noch in Betrieb.<br>Seit 1994 wurde das Schienennetz um 5100 Kilometer reduziert."
            }
            if (this.optionChoosen == "Option3") {
                smartAppMsg= "Das haben Sie Recht. Die Lage des deutschen Schiennetzes ist verbesserungswürdig! In den letzten 25 Jahren hat der Personenverkehr um 40,8 Prozent und der Güterverkehr um 83,4 Prozent zugenommen, während das Schienennetz um 14,9 Prozent verkleinert wurde. <br><br><b>33.000 Kilometer </b><br>sind heute noch in Betrieb.<br>Seit 1994 wurde das Schienennetz um 5100 Kilometer reduziert."
            }
                        
            return (smartAppMsg)
            }
            
       

    },
  methods: {
        generateOption1: function () {
            if (this.hasChoosen==true){
                this.hasChoosen = false;
                this.optionChoosen = "";
            } else {
            this.hasChoosen=true;
             this.hasQuizForm = false;
             this.optionChoosen = "Option1";
           
           }  
        },
         generateOption2: function () {
            if (this.hasChoosen==true){
                this.hasChoosen = false;
                this.optionChoosen = "";
            } else {
            this.hasChoosen=true;
             this.hasQuizForm = false;
             this.optionChoosen = "Option2";
           
           }  
        },
         generateOption3: function () {
            if (this.hasChoosen==true){
                this.hasChoosen = false;
                this.optionChoosen = "";
            } else {
            this.hasChoosen=true;
             this.hasQuizForm = false;
             this.optionChoosen = "Option3";
           
           }  
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../assets/styles.css';
</style>
